
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire893f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire893f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $72z4V = parcelRequire("72z4V");

var $l8biK = parcelRequire("l8biK");

var $le7Hi = parcelRequire("le7Hi");
/* eslint-disable */ // this is an auto generated file. This will be overwritten
const $2af249225bdc8257$export$9648cadeaf64ccee = /* GraphQL */ `
  mutation CreateVote(
    $input: CreateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    createVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$export$8d49ed41db4e822e = /* GraphQL */ `
  mutation UpdateVote(
    $input: UpdateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    updateVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$export$cd544f3ce43f52a7 = /* GraphQL */ `
  mutation DeleteVote(
    $input: DeleteVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    deleteVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;


// Generates the animated Cedys backdrop (drips, sparkles, ambient motes, bokeh).
// Shared by index.html (promo) and vote.html (ballot); pairs with css/effects.css.
const $615881e70c452140$var$reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function $615881e70c452140$var$fill(id, count, build) {
    const container = document.getElementById(id);
    if (!container) return;
    for(let i = 0; i < count; i++)container.appendChild(build());
}
function $615881e70c452140$var$createDrips() {
    $615881e70c452140$var$fill("drips", Math.floor(window.innerWidth / 25), ()=>{
        const drip = document.createElement("div");
        drip.className = "drip";
        drip.style.left = `${Math.random() * 100}%`;
        drip.style.height = `${80 + Math.random() * 200}px`;
        drip.style.animationDuration = `${4 + Math.random() * 6}s`;
        drip.style.animationDelay = `${Math.random() * 10}s`;
        drip.style.opacity = 0.3 + Math.random() * 0.5;
        return drip;
    });
}
function $615881e70c452140$var$createSparkles() {
    const types = [
        "gold",
        "warm",
        "deep"
    ];
    $615881e70c452140$var$fill("sparkles", Math.floor(window.innerWidth / 12), ()=>{
        const sparkle = document.createElement("div");
        sparkle.className = `sparkle ${types[Math.floor(Math.random() * types.length)]}`;
        const size = 2 + Math.random() * 6;
        sparkle.style.left = `${Math.random() * 100}%`;
        sparkle.style.width = `${size}px`;
        sparkle.style.height = `${size}px`;
        sparkle.style.animationDuration = `${3 + Math.random() * 4}s`;
        sparkle.style.animationDelay = `${Math.random() * 5}s`;
        return sparkle;
    });
}
function $615881e70c452140$var$createAmbient() {
    $615881e70c452140$var$fill("ambient", 30, ()=>{
        const particle = document.createElement("div");
        particle.className = "ambient";
        const size = 1 + Math.random() * 3;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${20 + Math.random() * 60}%`;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.animationDuration = `${3 + Math.random() * 4}s`;
        particle.style.animationDelay = `${Math.random() * 5}s`;
        return particle;
    });
}
function $615881e70c452140$var$createGlitter() {
    // Scale with viewport area, but cap it — this page gets hammered on show night
    // and phones pay for every animated node.
    const area = window.innerWidth * window.innerHeight;
    const cap = window.innerWidth < 700 ? 55 : 130;
    const count = Math.max(24, Math.min(cap, Math.round(area / 9000)));
    $615881e70c452140$var$fill("glitter", count, ()=>{
        const glitter = document.createElement("div");
        const warm = Math.random() < 0.28;
        glitter.className = warm ? "glitter warm" : "glitter";
        const size = (warm ? 17 : 10) + Math.random() * (warm ? 14 : 11);
        glitter.style.left = `${Math.random() * 100}%`;
        glitter.style.top = `${Math.random() * 100}%`;
        glitter.style.width = `${size}px`;
        glitter.style.height = `${size}px`;
        glitter.style.marginLeft = `${-size / 2}px`;
        glitter.style.marginTop = `${-size / 2}px`;
        // Long, staggered cycles so the field twinkles sporadically instead of pulsing.
        glitter.style.animationDuration = `${2.2 + Math.random() * 3.4}s`;
        glitter.style.animationDelay = `${Math.random() * 9}s`;
        return glitter;
    });
}
function $615881e70c452140$var$createBokeh() {
    const colors = [
        "rgba(255, 192, 46, 0.15)",
        "rgba(250, 157, 8, 0.12)",
        "rgba(202, 157, 74, 0.1)",
        "rgba(226, 188, 114, 0.08)"
    ];
    $615881e70c452140$var$fill("bokeh", 12, ()=>{
        const bokeh = document.createElement("div");
        bokeh.className = "bokeh";
        const size = 30 + Math.random() * 100;
        const color = colors[Math.floor(Math.random() * colors.length)];
        bokeh.style.left = `${Math.random() * 100}%`;
        bokeh.style.top = `${Math.random() * 100}%`;
        bokeh.style.width = `${size}px`;
        bokeh.style.height = `${size}px`;
        bokeh.style.background = `radial-gradient(circle, ${color} 0%, transparent 70%)`;
        bokeh.style.animationDuration = `${4 + Math.random() * 4}s`;
        bokeh.style.animationDelay = `${Math.random() * 4}s`;
        return bokeh;
    });
}
function $615881e70c452140$var$build() {
    $615881e70c452140$var$createDrips();
    $615881e70c452140$var$createSparkles();
    $615881e70c452140$var$createAmbient();
    $615881e70c452140$var$createGlitter();
    $615881e70c452140$var$createBokeh();
}
function $615881e70c452140$var$clear() {
    [
        "drips",
        "sparkles",
        "ambient",
        "glitter",
        "bokeh"
    ].forEach((id)=>{
        const el = document.getElementById(id);
        if (el) el.innerHTML = "";
    });
}
function $615881e70c452140$export$f507083e0796c877() {
    if ($615881e70c452140$var$reduceMotion) {
        // css/effects.css already hides the moving layers; skip the DOM churn entirely.
        $615881e70c452140$var$createBokeh();
        return;
    }
    $615881e70c452140$var$build();
    let resizeTimeout;
    window.addEventListener("resize", ()=>{
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(()=>{
            $615881e70c452140$var$clear();
            $615881e70c452140$var$build();
        }, 250);
    });
}


(0, $72z4V.DefaultAmplify).configure((0, (/*@__PURE__*/$parcel$interopDefault($le7Hi))));
const $e73bf42412feb220$var$client = (0, $l8biK.generateClient)();
// ---------------------------------------------------------------------------
// Per-show configuration — this is the only block that changes year to year.
// ---------------------------------------------------------------------------
// Confirmed for 2026: four votes per viewer, matching SBGC 2026. The Cedys ran
// a single-vote ballot in 2024/2025, so this is a deliberate change — the
// cookie names below are year-suffixed, so returning viewers start fresh and
// won't inherit a 2025 single-vote cookie.
const $e73bf42412feb220$var$MAX_VOTES = 4;
// Cookies are namespaced per show year so a returning viewer starts fresh.
const $e73bf42412feb220$var$VOTE_COOKIE = "cedysvote26";
const $e73bf42412feb220$var$COUNT_COOKIE = "cedysvotecount26";
// Broadcast is Friday, September 18 2026 (8/7c) — this sits well past it so a
// viewer's ballot state survives the whole show night and any repeat airings.
const $e73bf42412feb220$var$COOKIE_EXPIRES = "Thu, 31 Dec 2026 23:59:59 GMT";
// Voting opens at 8:00pm ET on show night: midnight UTC, since September is
// EDT (UTC-4). Until then "/" shows the promo and a vote click does nothing;
// at this instant the ballot takes over on its own. See applyGate() below.
const $e73bf42412feb220$var$OPENS_AT = Date.parse("2026-09-19T00:00:00Z");
const $e73bf42412feb220$var$OPENS_MESSAGE = "Voting opens at 8pm ET!";
// Flip to false after the show to freeze the ballot, and name the winner's
// slug (the option's id in index.html and vote.html) so its checkmark is shown.
const $e73bf42412feb220$var$VOTING_OPEN = false;
const $e73bf42412feb220$var$WINNER = "beatboxer26";
const $e73bf42412feb220$var$CLOSED_MESSAGE = "Voting is closed. See you next year!";
// ---------------------------------------------------------------------------
function $e73bf42412feb220$var$readCookie(name) {
    const cookie = document.cookie.split("; ").find((row)=>row.startsWith(name + "="));
    return cookie ? cookie.split("=")[1] : null;
}
function $e73bf42412feb220$var$writeCookie(name, value) {
    document.cookie = name + "=" + value + "; expires=" + $e73bf42412feb220$var$COOKIE_EXPIRES + "; Secure";
}
function $e73bf42412feb220$var$getVoteCount() {
    const raw = $e73bf42412feb220$var$readCookie($e73bf42412feb220$var$COUNT_COOKIE);
    const count = raw ? parseInt(raw, 10) : 0;
    return Number.isNaN(count) ? 0 : count;
}
function $e73bf42412feb220$var$setVoteCount(count) {
    $e73bf42412feb220$var$writeCookie($e73bf42412feb220$var$COUNT_COOKIE, count);
}
function $e73bf42412feb220$var$getLastVote() {
    return $e73bf42412feb220$var$readCookie($e73bf42412feb220$var$VOTE_COOKIE);
}
function $e73bf42412feb220$var$setLastVote(votedFor) {
    $e73bf42412feb220$var$writeCookie($e73bf42412feb220$var$VOTE_COOKIE, votedFor);
}
// A vote counts as cast on the client the moment the button is pressed, whether
// or not AppSync answers — a viewer who taps once should never be asked twice.
function $e73bf42412feb220$var$recordVote(votedFor, currentCount) {
    $e73bf42412feb220$var$setVoteCount(currentCount + 1);
    $e73bf42412feb220$var$setLastVote(votedFor);
    document.getElementById(votedFor).classList.add("yes");
    document.getElementById("instructions").innerText = "Thanks for voting!";
}
// ---------------------------------------------------------------------------
// Showtime switch. "/" carries both the promo and the ballot, and this decides
// which one is up and whether a click can record a vote — so nothing has to be
// deployed or changed in the console at 8pm.
// ---------------------------------------------------------------------------
// The gate runs on AppSync's clock rather than the viewer's. The site's own Date
// header is useless for this: CloudFront caches the HTML (s-maxage is a year)
// and freezes Date at cache-fill time. AppSync responses are never cached and
// expose Date to the browser, and `{ __typename }` touches no data source.
let $e73bf42412feb220$var$clockOffset = 0;
let $e73bf42412feb220$var$clockSettled = false;
let $e73bf42412feb220$var$clockReady = Promise.resolve();
let $e73bf42412feb220$var$currentState = null;
async function $e73bf42412feb220$var$syncClock() {
    const abort = new AbortController();
    const timeout = setTimeout(()=>abort.abort(), 5000);
    try {
        const sent = Date.now();
        const res = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($le7Hi))).aws_appsync_graphqlEndpoint, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "x-api-key": (0, (/*@__PURE__*/$parcel$interopDefault($le7Hi))).aws_appsync_apiKey
            },
            body: JSON.stringify({
                query: "{ __typename }"
            }),
            signal: abort.signal
        });
        const received = Date.now();
        const serverTime = Date.parse(res.headers.get("Date"));
        if (!Number.isNaN(serverTime)) // Date is truncated to the whole second, so take the middle of it, and
        // assume it was stamped halfway through the round trip.
        $e73bf42412feb220$var$clockOffset = serverTime + 500 - (sent + received) / 2;
    } catch (err) {
        // Fall back to the device clock rather than holding the ballot shut.
        console.error(err);
    } finally{
        clearTimeout(timeout);
        $e73bf42412feb220$var$clockSettled = true;
    }
}
function $e73bf42412feb220$var$votingHasOpened() {
    return Date.now() + $e73bf42412feb220$var$clockOffset >= $e73bf42412feb220$var$OPENS_AT;
}
// Only "/" has a promo block. /vote keeps its ballot up throughout so it can be
// reviewed before the show.
function $e73bf42412feb220$var$setPromoVisible(visible) {
    const promo = document.getElementById("promo");
    if (!promo) return;
    promo.hidden = !visible;
    document.getElementById("ballot").hidden = visible;
    // Over the key art the Instagram CTA sits bare; on the ballot it gets the
    // orange panel and CLICK prompt, matching /vote.
    const follow = document.getElementById("follow");
    follow.classList.toggle("plain", visible);
    follow.querySelectorAll(".click").forEach((el)=>el.hidden = visible);
}
// Puts the page in whichever state the clock and config call for, touching the
// DOM only when that state changes. Returns the state.
function $e73bf42412feb220$var$applyGate() {
    const state = !$e73bf42412feb220$var$VOTING_OPEN ? "closed" : $e73bf42412feb220$var$votingHasOpened() ? "open" : "waiting";
    if (state === $e73bf42412feb220$var$currentState) return state;
    $e73bf42412feb220$var$currentState = state;
    const options = document.getElementById("options");
    const instructions = document.getElementById("instructions");
    options.classList.remove("novote", "done");
    options.querySelectorAll(".yes").forEach((el)=>el.classList.remove("yes"));
    if (state === "waiting") {
        $e73bf42412feb220$var$setPromoVisible(true);
        options.classList.add("novote");
        instructions.innerText = $e73bf42412feb220$var$OPENS_MESSAGE;
    } else if (state === "closed") {
        $e73bf42412feb220$var$setPromoVisible(false);
        options.classList.add("done");
        if ($e73bf42412feb220$var$WINNER) document.getElementById($e73bf42412feb220$var$WINNER).classList.add("yes");
        instructions.innerText = $e73bf42412feb220$var$CLOSED_MESSAGE;
    } else if ($e73bf42412feb220$var$getVoteCount() >= $e73bf42412feb220$var$MAX_VOTES) {
        $e73bf42412feb220$var$setPromoVisible(false);
        const lastVote = $e73bf42412feb220$var$getLastVote();
        options.classList.add("done");
        if (lastVote && document.getElementById(lastVote)) document.getElementById(lastVote).classList.add("yes");
        instructions.innerText = "Thanks for voting!";
    } else {
        $e73bf42412feb220$var$setPromoVisible(false);
        options.classList.add("novote");
        instructions.innerText = "Vote for your favorite!";
    }
    return state;
}
async function $e73bf42412feb220$var$sendVote(e) {
    const votedFor = e.target.dataset.ad;
    // A click that lands before the clock sync finishes waits for it, rather than
    // being judged on the device clock.
    await $e73bf42412feb220$var$clockReady;
    const currentCount = $e73bf42412feb220$var$getVoteCount();
    if (!$e73bf42412feb220$var$VOTING_OPEN || currentCount >= $e73bf42412feb220$var$MAX_VOTES) return;
    if ($e73bf42412feb220$var$applyGate() !== "open") return;
    document.getElementById("options").classList.remove("novote");
    document.getElementById("options").classList.add("done");
    document.getElementById("instructions").innerText = "Processing your vote...";
    // Guarded: an ad blocker can leave gtag undefined, and a throw here would
    // otherwise skip the createVote call entirely and lose the vote.
    if (typeof gtag === "function") gtag("event", votedFor);
    try {
        const newVote = await $e73bf42412feb220$var$client.graphql({
            query: (0, $2af249225bdc8257$export$9648cadeaf64ccee),
            variables: {
                input: {
                    vote: votedFor
                }
            }
        });
        console.log(newVote);
    } catch (err) {
        console.error(err);
    }
    $e73bf42412feb220$var$recordVote(votedFor, currentCount);
}
function $e73bf42412feb220$var$init() {
    console.log("run init");
    (0, $615881e70c452140$export$f507083e0796c877)();
    document.getElementById("termsLink").onclick = function() {
        document.getElementById("terms").classList.toggle("show");
    };
    document.querySelectorAll("[data-promo]").forEach((el)=>{
        el.addEventListener("click", ()=>{
            if (typeof gtag === "function") gtag("event", "promo_" + el.dataset.promo);
        });
    });
    document.querySelectorAll(".vote").forEach((item)=>{
        item.addEventListener("click", $e73bf42412feb220$var$sendVote);
    });
    // First pass on the device clock, so an accurate one — the common case —
    // never flashes the wrong page. The sync then corrects it against AppSync.
    if ($e73bf42412feb220$var$applyGate() === "closed") return;
    $e73bf42412feb220$var$clockReady = $e73bf42412feb220$var$syncClock().then($e73bf42412feb220$var$applyGate);
    const tick = setInterval(()=>{
        if ($e73bf42412feb220$var$clockSettled && $e73bf42412feb220$var$applyGate() === "open") clearInterval(tick);
    }, 1000);
    // Background tabs get their timers throttled; catch up the moment one is shown.
    document.addEventListener("visibilitychange", ()=>{
        if (!document.hidden) $e73bf42412feb220$var$applyGate();
    });
}
window.onload = function() {
    $e73bf42412feb220$var$init();
};


//# sourceMappingURL=index.cd98bd00.js.map
